import { getImageNameWithoutExtensions } from '../../../../shared/Helpers';
import { ImageInfo } from '../annotation.types';
import { Settings } from '../../../../shared/constants';

export class DirectionOptions {
  static readonly UP = -1;
  static readonly DOWN = 1;
}

export type Direction = -1 | 1;

export const getNextImage = (images: ImageInfo[], selectedName: string, upDown: Direction) => {
  const currentImage = images.find(item => getImageNameWithoutExtensions(item.filename) === getImageNameWithoutExtensions(selectedName));
  if (!currentImage) {
    return;
  }
  const currentIndex = images.indexOf(currentImage);
  const edgeIndexToCompare = upDown === DirectionOptions.UP ? 0 : images.length - 1;
  const skipWithoutML = localStorage.getItem(Settings.SkipWithoutML) === 'true';

  let nextIndex = currentIndex;

  while (true) {
    if (nextIndex === edgeIndexToCompare) {
      return null;
    }

    nextIndex = nextIndex + upDown;
    const nextImage = images[nextIndex];

    if ((nextImage.annotations && nextImage.annotations.some(x => x.isMlProposal) && skipWithoutML) || !skipWithoutML) {
      break;
    }

    continue;
  }

  return images[nextIndex!];
};

export const getNextAnnotation = (gridData: any, selectedAnnotationId: string, upDown: Direction) => {
  const currentAnnotation = gridData.find((finding: any) => finding.id === selectedAnnotationId);
  if (!currentAnnotation) {
    return;
  }

  const currentIndex = gridData.indexOf(currentAnnotation);
  const edgeIndexToCompare = upDown === DirectionOptions.UP ? 0 : gridData.length - 1;

  let nextIndex = currentIndex;

  if (nextIndex === edgeIndexToCompare) {
    return null;
  }

  nextIndex = nextIndex + upDown;

  return gridData[nextIndex!];
};
